import axios from 'axios';
import {
  requestHandler,
  successHandler,
  errorHandler,
} from '../interceptors';
import {
  getToken,
} from '../../login.js';

// add your BASE_URL to Constants file
export const axiosInstance = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
    token: getToken(),
  },
});

// Handle request process
axiosInstance.interceptors.request.use(request => requestHandler(request));
// Handle response process
axiosInstance.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error),
);

export const axiosDefault = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    token: getToken(),
  },
});

// Handle request process
axiosDefault.interceptors.request.use(request => requestHandler(request));
// Handle response process
axiosDefault.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error),
);
